export const getPagination = (data, pageSize) => {
    let result = [];
    let pageNumber = getPageNumber(data, pageSize);


    for (var i = 0; i < pageNumber; i++) {
        let page = data.slice(i * pageSize, i * pageSize + pageSize);
        result.push(page);
    }
    return result;
}

export const getPageNumber = (data, pageSize) => {
    let pageNumber = Math.ceil(data.length / pageSize);
    return pageNumber;
}

